<!-- This icon is from <https://github.com/Templarian/MaterialDesign>, distributed under Apache 2.0 (https://www.apache.org/licenses/LICENSE-2.0) license-->
<template>
  <svg class="loading-image" viewBox="0 0 100 100" :class="{ 'animate': animate }">
    <circle class="track"   cx="50" cy="50" r="40"/>
    <circle class="spinner" cx="50" cy="50" r="40"/>
  </svg>
</template>
<script setup lang="ts">

withDefaults(defineProps<{
  size?: number | string
  color?: string
  animate?: boolean
  strokeWidth?: number
  ariaLabel?: string
}>(), {
  size: 24,
  color: 'currentColor',
  animate: true,
  strokeWidth: 2,
  ariaLabel: 'Loading'
})
</script>
<style scoped>
/* animated arc */

.loading-image {
  border: none;
  background: transparent;
}

.track{fill:none;stroke:#444;stroke-width:8;opacity:.25;}

.spinner{
  fill:none;
  stroke:#fff;
  stroke-width:8;
  stroke-linecap:round;
  /* circumference ≈ 2π*40 = 251 */
  stroke-dasharray:251;
  stroke-dashoffset:251;
  transform-origin:50% 50%;
}

.animate .spinner{
  animation:dash 1.4s ease-in-out infinite,
              spin 1.4s linear infinite;
}

@keyframes dash{
  0%   {stroke-dashoffset:251;}
  50%  {stroke-dashoffset:63;} /* 75% visible */
  100% {stroke-dashoffset:251;}
}

/* whole element rotates */
@keyframes spin{
  to{transform:rotate(360deg);}
}
</style>